import { Component, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { NgxDropzoneChangeEvent } from 'ngx-dropzone';
import { ExportUserFieldLabel } from '@/app/shared/interfaces/user.interface';
// import { Store } from '@ngxs/store';
// import { ImportUser } from '../../../../action/user.action';

@Component({
    selector: 'app-select-export-user-infor-modal',
    templateUrl: './select-export-user-infor-modal.component.html',
    styleUrls: ['./select-export-user-infor-modal.component.scss']
})
export class SelectExportUserInforModalComponent {
    public active = 'export';
    public closeResult: string | undefined;
    public modalOpen: boolean = false;
    public exportFields: { key: string; label: string; selected: boolean }[] = [];

    public files: File[] = [];

    @Input() module: string | undefined;
    @Output() fieldsSelected = new EventEmitter<string[]>();

    @ViewChild('SelectExportUserInforModal', { static: true }) SelectExportUserInforModal!: TemplateRef<any>;

    constructor(
        private modalService: NgbModal) {
    }
    ngOnInit() {
        this.exportFields = Object.entries(this.ExportUserFieldLabel).map(([key, value]) => ({
            key,
            label: value as string,
            selected: false
        }));
    }
    async openModal() {
        this.modalOpen = true;
        console.log("open modal");
        this.modalService.open(this.SelectExportUserInforModal, {
            ariaLabelledBy: 'Media-Modal',
            centered: true,
            windowClass: 'theme-modal modal-xl media-modal'
        }).result.then((result) => {
            `Result ${result}`
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    private getDismissReason(reason: ModalDismissReasons): string {
        this.active = 'export';
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    onSelect(event: NgxDropzoneChangeEvent) {
        this.files.push(...event.addedFiles);
    }

    onRemove(event: File) {
        this.files.splice(this.files.indexOf(event), 1);
    }

    ExportUserFieldLabel = ExportUserFieldLabel;

    public selectedFields = new Set<string>();

    toggleField(fieldKey: string) {
        const field = this.exportFields.find(f => f.key === fieldKey);
        if (!field) return;

        if (field.selected) {
            field.selected = false;
            this.selectedFields.delete(fieldKey);
        } else {
            field.selected = true;
            this.selectedFields.add(fieldKey);
        }
    }


    isSelected(fieldKey: string): boolean {
        console.log(fieldKey)
        return this.selectedFields.has(fieldKey);
    }

    export() {
        this.fieldsSelected.emit(Array.from(this.selectedFields));
        this.modalService.dismissAll();
    }
}